import { topicIndexItems } from '@/mocks/homeData';

export default function TopicIndex() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="section-title">热门专题</h2>
          <p className="section-subtitle">九大热门分类，精准定位你想吃的瓜</p>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-9 gap-3 md:gap-4">
          {topicIndexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center gap-2 p-3 md:p-4 rounded-xl bg-white border border-background-200 hover:border-primary-200 hover:shadow-sm transition-all cursor-pointer"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl ${item.bgColor} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} ${item.color} text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 text-center whitespace-nowrap group-hover:text-primary-500 transition-colors">
                {item.title}
              </span>
              <span className="text-xs text-foreground-400">
                {item.count}条
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}